import { LogAttributes } from "@/src/utils/observability/log-types";

// Ignore messages from specified types to avoid logging sensitive information
const IGNORED_ERROR_NAMES = new Set([
  "CombinedGraphQLErrors",
  "CombinedProtocolErrors",
]);

export const errorAttributes = (error: unknown): LogAttributes => {
  if (error instanceof Error) {
    const isIgnored = IGNORED_ERROR_NAMES.has(error.name);

    return {
      "exception.type": error.name,
      "exception.message": isIgnored ? undefined : error.message,
      "exception.stacktrace": isIgnored ? undefined : error.stack,
    };
  }

  if (typeof error === "string") {
    return { "exception.message": error };
  }

  return error === undefined ? {} : { "exception.type": typeof error };
};
